export const slides = [

    {
        src:"Dibujos/DameCorset.jpg",
        title: "Dame au corset",
        description:"50 x 42 cm, 2026",
        price: "420€"
    },
    {
        src:"Dibujos/pour-soi-en-soi2.jpeg",
        title: "Pour-soi-en-soi",
        description:"56 x 42 cm, 2026",
        price: "420€"
    },
    {
        src:"Dibujos/En-soi-pour-soi.jpg",
        title: "En-soi-pour-soi",
        description:"35.6 x 43.2 cm, 2024",
        price: "380€"
    },
    {
        src:"Dibujos/frijoles.JPG",
        title: "P'tit déjeuner",
        description:"35.6 x 43.2 cm, 2024",
        price: "380€"
    },
    {
        src:"Dibujos/Fantome.jpg",
        title: "Temple d'enfance",
        description:"75 x 55 cm, 2024",
        price: "450€"
    },
    {
        src:"Dibujos/Ineinander.jpg",
        title: "Inneinader",
        description:"43.2 x 35.6 cm, 2024",
        price: "380€"
    },
    {
        src:"Dibujos/huerfanita.JPG",
        title: "Orpheline",
        description:"35.6 x 43.2 cm, 2024",
        price: "380€"
    },
    {
        src:"Dibujos/cochecito.jpg",
        title: "P'tite voiture",
        description:"35.6 x 43.2 cm, 2024",
        price: "380€"
    },
    {
        src:"Dibujos/IMG_0255.jpg",
        title: "Pathos",
        description:"43.2 x 35.6 cm, 2024",
        price: "380€"
    },
    {
        src:"Dibujos/goustos.jpg",
        title: "Goûts",
        description: "35.6 x 43.2 cm, 2023",
        price: "350€"
    },
    



];

